import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 467,
	height: 567,
	viewBox: "0 0 467 567",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M166.667 500V233.333C166.667 196.515 196.515 166.667 233.334 166.667C270.153 166.667 300.001 196.515 300.001 233.333V500C300 536.819 270.153 566.667 233.334 566.667C196.515 566.667 166.667 536.819 166.667 500Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M0 500V366.667C0 329.848 29.848 300 66.667 300C103.486 300 133.334 329.848 133.334 366.667V500C133.334 536.819 103.486 566.667 66.667 566.667C29.848 566.667 0 536.819 0 500Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M333.333 500V66.667C333.333 29.848 363.181 0 400 0C436.819 0 466.667 29.848 466.667 66.667V500C466.667 536.819 436.819 566.667 400 566.667C363.181 566.667 333.333 536.819 333.333 500Z" })
	]
});
export default SvgChart;
